import { render, staticRenderFns } from "./radish-left.vue?vue&type=template&id=47be9929&"
import script from "./radish-left.vue?vue&type=script&lang=js&"
export * from "./radish-left.vue?vue&type=script&lang=js&"
import style0 from "./radish-left.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports